export enum VerifierFormNames {
  Hero = "hero",
  OurExpertise = "ourMission",
  CodesAndStandards = "standards",
  AtAGlance = "atAGlance",
  OurServices = "ourServices",
  AboutUs = "aboutUs",
}
